<template>
  <div class="header">
    <span class="header-title" v-if="$route.query.flag == 'login'">{{ $t('lang.欢迎光临，请根据步骤指示设置您的登录密码！') }}</span>
    <span class="header-title" v-else>{{ $t('lang.请根据步骤指示重新设置您的登录密码') }}！</span>
    <el-button round @click="$router.push('/login')" >{{ $t('lang.返回登录页') }}</el-button>
  </div>
</template>

<script>
export default {
  name: "SetPasswordHeader",
}
</script>

<style scoped lang="scss">

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-title {
    font-weight: bold;
  }
}

</style>
